// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"573":"b220c5c9","693":"5cf641bf"}[chunkId] + ".chunk.js";
};